import ko from 'knockout';
import _ from 'lodash';

ko.extenders.fromJSMapLocked = target => {
	target
		.extend({ locked: false })
		.extend({
			fromJSMap: v => {
				const hasValue = _.isArray(v)
					? _.isEmpty(v)
					: v || v === false || v === 0;
				target.locked(hasValue);
				return v;
			},
		});
};
